import { ValidationErrors } from '@angular/forms';

export const validationMessages: ValidationErrors = {
  required: 'required',
  minlength: 'minlength',
  maxlength: 'maxlength',
  pattern: 'forbiddenEntry',
  email: 'emailInvalid',
  invalidUrl: 'invalidUrl',
  date: 'dateInvalid',
  matDatepickerParse: 'dateInvalid',
  matDatepickerMin: 'min',
  matDatepickerMax: 'max',
  matDatetimePickerParse: 'dateInvalid',
  matDatetimePickerMin: 'min',
  matDatetimePickerMax: 'max',
  min: 'min',
  max: 'max',
  departmentRequiredValidator: 'departmentRequired',
  whitespace: 'noWhitespace',
  invalidPhoneNumber: 'invalidPhoneNumber',
  startAfterEndDate: 'startDateMustBeBeforeEndDate',
  onlyIntegers: 'onlyIntegers',
};

export const rangeValueMessages: ValidationErrors = {
  ...validationMessages,
  min: 'minValue',
  max: 'maxValue',
};
